<template>
    <span
        ref="tooltip"
        class="o-tooltip"
        :class="`o-tooltip--${position}`"
    >
        <span
            ref="icon"
            class="o-tooltip__icon"
        >
        </span>
        <span
            ref="inner"
            class="o-tooltip__inner"
        >
            <span class="o-tooltip__content">
                <slot/>
            </span>
        </span>
    </span>
</template>

<script>/* eslint-disable */

    import debounce from 'lodash/debounce';

    export default {
        name: 'Tooltip',
        data: () => ({
            position: 'left',
            onResize: null,
        }),
        methods: {
            setPosition() {

                // Define vars
                const $tooltip = this.$refs.tooltip;
                const pos = this.$refs.tooltip.getBoundingClientRect();
                const innerWidth = this.$refs.inner.offsetWidth;
                const windowWidth = window.innerWidth
                const iconWidth = this.$refs.icon.offsetWidth

                if (pos.left + innerWidth < windowWidth) {
                    this.position = 'left'
                    $tooltip.style.setProperty('--x', '0px');
                } else if (pos.left > innerWidth) {
                    $tooltip.style.setProperty('--x', `${iconWidth - innerWidth}px`);
                    this.position = 'right'
                } else {
                    this.position = 'center'
                    $tooltip.style.setProperty('--x', `${-(pos.left + innerWidth - windowWidth)}px`);
                }
            },
        },
        mounted() {
            // Set tooltip position
            this.setPosition()

            // Reset position on window resize
            window.addEventListener('resize', this.onResize = debounce(this.setPosition, 100))
        },
        beforeDestroy() {
            // Unbind resize event
            window.removeEventListener('resize', this.onResize)
        }
    }

</script>

<style lang="scss">

    .o-tooltip {
        --x: 0px;

        // z-index: 0;
        // top: .25em;
        display: inline-block;
        margin-right: .2em;
        margin-left: .2em;
        transition: z-index 0s .6s;

        &--left {

            .o-tooltip__inner {
                border-top-left-radius: 1em;
            }
        }

        &--right {

            .o-tooltip__inner {
                border-top-right-radius: 1em;
                transform-origin: 100% 0;
            }
        }

        &--center {

            .o-tooltip__inner {
                padding-top: 2em;
                transform-origin: 50% 0;
            }
        }

        &:hover {
            z-index: 800;
            transition: z-index 0s 0s;

            .o-tooltip__icon {
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                transition: box-shadow .4s $out-sine;
            }

            .o-tooltip__inner {
                opacity: 1;
                transform: scale(1);
                transition: opacity .4s $out-sine, transform .4s $out-expo;
            }

            .o-tooltip__content {
                opacity: 1;
                transform: rotateX(0);
                transition: opacity .2s $out-sine .2s, transform .2s $out-sine .2s;
            }
        }
    }

    .o-tooltip__icon {
        z-index: 1;
        display: block;
        width: 1.5em;
        height: 1.5em;
        background-color: $color-light;
        border-radius: 50%;
        box-shadow: $shadow;
        transition: box-shadow .15s $in-sine 0s;

        &:after {
            @include pseudo-el($width: .5em, $height: .5em, $bg: $color-primary);
            position: absolute;
            top: calc(50% - .5em/2);
            left: calc(50% - .5em/2);
            border-radius: inherit;
        }
    }

    .o-tooltip__inner {
        position: absolute;
        top: 0;
        left: var(--x);
        width: 100vw;
        max-width: 14.5em;
        padding: 1em 2em;
        background-color: $color-light;
        border-radius: $radius;
        box-shadow: $shadow;

        opacity: 0;
        transform: scale(0);
        transform-origin: 0 0;
        transition: opacity .25s $in-quad 0s, transform .25s $in-quad .05s;
    }

    .o-tooltip__content {
        display: block;
        opacity: 0;
        transform: rotateX(15deg);
        transform-origin: 0 0;
        transition: opacity .15s $in-sine 0s, transform .15s $in-sine 0s;
    }

</style>
